export default __webpack_public_path__ + "static/media/Screenshotmemories.1fe7d5a6.png";